module.exports = __webpack_public_path__ + "static/powerbi-merge-values-replace-1-0d74de861104b6b4cc8787e24256b4ba.png";